var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"user-settings py-4 py-sm-6",attrs:{"fluid":""}},[_c('list',{staticClass:"mb-5",attrs:{"hide-create":true},on:{"access-management":function($event){_vm.canManageAccess = $event}}}),_c('invite',{attrs:{"can-manage-access":_vm.canManageAccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }